<template>
  <el-menu class="navbar">
    <hamburger
      id="hamburger-container"
      @toggleClick="toggleSideBar"
      :is-active="sidebar.opened"
      class="hamburger-container"
    />
    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <el-button
        class="permission-refresh"
        type="text"
        icon="el-icon-refresh"
        :loading="permissionRefreshing"
        @click="refreshPermissions"
        >权限刷新</el-button
      >
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <!-- <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar"> -->
          <!--          <img src="@/assets/avatar.gif" class="user-avatar" />-->
          <img :src="logo" class="user-avatar" />
          <span>{{ username }}</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item disabled>
            {{ username }}
          </el-dropdown-item>
          <router-link class="inlineBlock" to="/info">
            <el-dropdown-item divided>
              修改密码
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item>
            <span style="display:block;" @click="logout">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </el-menu>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import { refreshPermMenu } from "@/api/login";
import { getUser, setMenus, setMenusCheckKey, setUser } from "@/utils/auth";

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters(["sidebar", "avatar"])
  },
  data() {
    return {
      logo: this.$store.state.settings.logo,
      permissionRefreshing: false,
      username: getUser() && Object.keys(getUser()).length !== 0 ? getUser().name : ""
    };
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    refreshPermissions() {
      if (this.permissionRefreshing) return;
      this.permissionRefreshing = true;
      refreshPermMenu()
        .then(response => {
          if (!response || response.bizcode !== 100 || !response.data) return;
          const data = response.data;
          const menus = Array.isArray(data.menus) ? data.menus : [];
          setMenus(menus);
          setMenusCheckKey(true);
          setUser({ id: data.userId, name: data.name });
          this.$message.success("权限已刷新");
          window.setTimeout(() => window.location.reload(), 300);
        })
        .finally(() => {
          this.permissionRefreshing = false;
        });
    },
    logout() {
      this.$store.dispatch("FedLogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 56px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  box-shadow: 0px 3px 14px 0px rgba(192, 194, 219, 0.2);
  border-bottom: 1px solid rgba(255, 255, 255, 0.13);
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .permission-refresh {
      height: 56px;
      margin-right: 8px;
      padding: 0 10px;
      color: #606266;
      font-size: 14px;
      vertical-align: top;
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        .user-avatar {
          cursor: pointer;
          width: 32px;
          height: 32px;
          margin-right: 10px;
          border-radius: 16px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 20px;
          font-size: 12px;
        }
      }
    }
  }
}

.hasTagsView {
  .navbar {
    // box-shadow: none;
  }
}
</style>
